import Hero from './components/Hero';
import Products from './components/Products';
import Design from './components/Design';
import Partners from './components/Partners';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Products />
      <Design />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
}